import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/findTemplateTable${`?query=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/findTemplateTable`;

export const URL = (tableRequestModel: TableQuery): RouteDefinition => `${baseRoute}/findTemplateTable?query=${encodeURIComponent((JSON.stringify(tableRequestModel)))}`;
